/* 


@PRAKT


   _____________________________________________________________

   |
   | INSTANCES
   |
   _____________________________________________________________
*/

import Gallery from "./Gallery";
import Drawer from "./Drawer";

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class Instances {
	constructor() {
		this.init();
	}

	init() {
        this.gallery_instances = [];
        this.drawer_instances = [];
		this.setGalleries();
        this.setDrawers();
	}

    setGalleries() {
        this.galleries = document.querySelectorAll( '.block__content.block_gallery' );
        for (let i = 0; i < this.galleries.length; i++) {
            const gallery = new Gallery( this.galleries[ i ] );
            this.gallery_instances.push( gallery );
        }
    }

    setDrawers() {
        this.drawer_headers = document.querySelectorAll( '.block__content.block_drawer_header' );
        for (let i = 0; i < this.drawer_headers.length; i++) {
            const drawer = new Drawer( this.drawer_headers[ i ] );
            this.drawer_instances.push( drawer );
        }
        
    }
}